import React, {Component} from 'react';
import { Col, Row,Button, FormControl} from 'react-bootstrap';
import Datetime from 'react-datetime'
import moment from 'moment'
 import Select   from 'react-select'
 import {
    ADD_SELECTED_CONTRACTORS,CLEAR_SELECTED_CONTRACTORS
} from "actions/actionTypes";
import config from  '../../../../config';

export default class AMTSalesNotificationsSearchBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);

        this.state = {
             filterOptions: {
                  perPage: _.isUndefined(this.props.location.query.perPage) ? config.table.numberPerPage : this.props.location.query.perPage,
                 fromSentAt:_.isUndefined(this.props.location.query.fromSentAt) ? '' : moment(this.props.location.query.fromSentAt),
                 toSentAt:_.isUndefined(this.props.location.query.toSentAt) ? '' : moment(this.props.location.query.toSentAt),
                 Types: _.isUndefined(this.props.location.query.Types) ?  [] : _.isArray(this.props.location.query.Types) ? _.map(this.props.location.query.Types, function (value) {
                     return _.find(config.subscriptionTypes, {value:value})
                 }) : [_.find(config.subscriptionTypes, {value:this.props.location.query.Types})],
               // searchText: _.isUndefined(this.props.location.query.searchText) ? '' : this.props.location.query.searchText,

             }
        };

    };


    _handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.props.search();
        }
    }

    getSearchParams(filtersChanged = {} ) {

        var filterOptions = {...this.state.filterOptions, ...filtersChanged};

      var  queryParams = {addFields:[]};

        if (filterOptions.searchText !== '') {
            queryParams.searchText = filterOptions.searchText;
        }
        if (filterOptions.fromSentAt &&  moment(filterOptions.fromSentAt, 'MM-DD-YYYY',true).isValid() ) {
          //  queryParams.addFields.push('PublishedInShopifyChangeLogRecord')
            queryParams.fromSentAt= filterOptions.fromSentAt.toISOString()
        }
        if (filterOptions.toSentAt &&  moment(filterOptions.toSentAt, 'MM-DD-YYYY',true).isValid()  ) {
           // queryParams.addFields.push('PublishedInShopifyChangeLogRecord')
            queryParams.toSentAt = filterOptions.toSentAt.toISOString()
        }
         if (_.size(filterOptions.Types) > 0) {
            queryParams.Types = _.map(filterOptions.Types, 'value').join(',')
        }
        var customQueries = [
            {
                "$match":   {"SubscriptionCustomData.SignedUpFrom": 'dashboard'}
             }]

        queryParams.customQueries = JSON.stringify(customQueries)
       return {queryParams}
    }
    onChangePerPageNumber(option) {
        this.setState({'filterOptions': {...this.state.filterOptions, perPage: option.value}}, function () {
            this.props.search();
        });
    }
    onsearchTextChange(event) {
        var updateOptions = {...this.state.filterOptions, searchText: event.target.value};
        this.setState({'filterOptions': updateOptions});
    }

    render() {
        var self = this;


         return (
            <div className="contractor-search-block bot15">
                <Row className="show-grid">
                    <Col xs={6} md={3} className="top10">
                        <Select
                            tabIndex="0"
                            clearable={true}
                            multi
                            placeholder="Type"
                            options={ _.filter(_.map(config.subscriptionTypes, function (value, key) {
                                return {value: key, label: value.label}
                            }), item =>{
                                return _.includes(['PriceDrop', 'InStock'], item.value)
                            })}
                            onChange={(selectedOptions) => {
                                this.setState({'filterOptions': {...this.state.filterOptions, Types: selectedOptions}}, function () {
                                    this.props.search();
                                });
                            }}

                            value={self.state.filterOptions.Types}
                        />
                    </Col>
                    <Col xs={9} sm={4} md={4} lg={3} className="top10">
                        <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={false}
                                  onChange={(option) => {
                                      var isSameDate =  moment(this.state.filterOptions['fromSentAt']).isSame(option, 'day')
                                      this.setState({
                                          'filterOptions': {
                                              ...this.state.filterOptions,
                                              fromSentAt: option,
                                          }
                                      }, function () {
                                            this.props.search();
                                      });
                                  }}
                                  value={this.state.filterOptions.fromSentAt}
                                  inputProps={{placeholder: 'Sent Date From'}}
                        />
                    </Col>
                    <Col xs={9}  sm={4}  md={4} lg={3}  className="top10">
                        <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={false}
                                  onChange={(option) => {
                                      this.setState({
                                          'filterOptions': {
                                              ...this.state.filterOptions,
                                              toSentAt: option,
                                          }
                                      }, function () {
                                           this.props.search();
                                      });
                                  }}
                                  inputProps={{placeholder: 'Sent Date To'}}
                                  value={this.state.filterOptions.toSentAt}

                        />
                    </Col>


                    <Col md={3} xs={6} className="top10">
                        <button className="btn btn-primary" onClick={(event) => self.props.search({ })}
                                type="button">
                            Search
                        </button>
                    </Col>
                </Row>
            </div>
        );
    }
}



